<template>
  <div>
    <div class="text-area">
      <ConsentSentence/>
      <TextLink text="利用規約" @click-text="onClickKiyaku" />
      <TextLink text="プライバシーポリシー" @click-text="onClickPrivacy" />
      <TextLink text="同意して進む" @click-text="onClickAgree"/>
      <p v-if="isTest" class="text-red">テスト版</p>
    </div>
  </div>
</template>

<script>
import TextLink from '@/components/Atoms/TextLink'
import ConsentSentence from '@/components/Molecules/ConsentSentence'

export default {
  name: 'consetn-check',
  components: {
    TextLink,
    ConsentSentence
  },
  props: {
    isTest: { type: Boolean }
  },
  methods: {
    onClickAgree () {
      this.$emit('click-agree')
    },
    onClickKiyaku (url) {
      window.open('https://sites.google.com/suisuitabi.org/mitusrules/%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84', '_blank')
    },
    onClickPrivacy (url) {
      window.open('https://sites.google.com/suisuitabi.org/mitusrules/%E3%83%97%E3%83%A9%E3%82%A4%E3%83%90%E3%82%B7%E3%83%BC%E3%83%9D%E3%83%AA%E3%82%B7%E3%83%BC', '_blank')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './../../unified.scss';

</style>



// WEBPACK FOOTER //
// src/components/Organisms/ConsentCheck.vue